const isLocal = window.location.hostname === "localhost";

export const BASE_URL = isLocal
  ? "http://localhost:4000/api"
  : "https://api.tvaritenergy.in/api";

export const Image_URL = isLocal
  ? "http://localhost:4000"
  : "https://api.tvaritenergy.in";
